<template>
  <div class="page">
    <klfs-header tab="join"></klfs-header>

    <div class="page-wrapper">

      <div class="section-block index-bg-img">
        <img class="image" src="../../assets/join/banner.png" alt="">
      </div>

      <div class="section-block process-section" id="jmlc">
        <div class="section-block-wrap">
          <h1 class="section-title">加盟流程</h1>
          <div class="process-content">
            <div class="brand-progress-view flex flex-align-bottom flex-just-center brand-progress-top">
              <div class="brand-progress-item">
                <p class="brand-progress-text">加盟申请</p>
                <div class="brand-year">
                  <img src="../../assets/join/process1.png" alt="">
                </div>
                <div class="brand-number">01</div>
              </div>
              <div class="brand-progress-item">
                <p class="brand-progress-text">地址选择</p>
                <div class="brand-year">
                  <img src="../../assets/join/process3.png" alt="">
                </div>
                <div class="brand-number">03</div>
              </div>
              <div class="brand-progress-item">
                <p class="brand-progress-text">店面设计</p>
                <div class="brand-year">
                  <img src="../../assets/join/process5.png" alt="">
                </div>
                <div class="brand-number">05</div>
              </div>
              <div class="brand-progress-item">
                <p class="brand-progress-text">新店辅导</p>
                <div class="brand-year">
                  <img src="../../assets/join/process7.png" alt="">
                </div>
                <div class="brand-number">07</div>
              </div>
              <div class="brand-progress-item"></div>
            </div>
            <div class="brand-progress-line"></div>
            <div class="brand-progress-view flex flex-just-center brand-progress-bottom">
              <div class="brand-progress-item"></div>
              <div class="brand-progress-item">
                <div class="brand-number">02</div>
                <div class="brand-year">
                  <img src="../../assets/join/process2.png" alt="">
                </div>
                <p class="brand-progress-text">合同签署</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-number">04</div>
                <div class="brand-year">
                  <img src="../../assets/join/process4.png" alt="">
                </div>
                <p class="brand-progress-text">人员培训</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-number">06</div>
                <div class="brand-year">
                  <img src="../../assets/join/process6.png" alt="">
                </div>
                <p class="brand-progress-text">证件办理</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-number">08</div>
                <div class="brand-year">
                  <img src="../../assets/join/process8.png" alt="">
                </div>
                <p class="brand-progress-text">正式开业</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block store-face-section" id="mdxx">
        <div class="section-block-wrap">
          <h1 class="section-title">门店形象</h1>
          <div class="store-face-content flex">
            <div class="store-face-col">
              <h3 class="store-face-title">
                <span>主力店型</span>
              </h3>
              <div class="store-face-list">
                <div class="store-face-item">
                  <img src="../../assets/join/main1.png" alt="">
                </div>
                <div class="store-face-item">
                  <img src="../../assets/join/main2.png" alt="">
                </div>
                <div class="store-face-item">
                  <img src="../../assets/join/main3.png" alt="">
                </div>
              </div>
            </div>
            <div class="store-face-col">
              <h3 class="store-face-title">
                <span>商超店型</span>
              </h3>
              <div class="store-face-list">
                <div class="store-face-item">
                  <img src="../../assets/join/market1.png" alt="">
                </div>
                <div class="store-face-item">
                  <img src="../../assets/join/market2.png" alt="">
                </div>
                <div class="store-face-item">
                  <img src="../../assets/join/market3.png" alt="">
                </div>
              </div>
            </div>
            <div class="store-face-col">
              <h3 class="store-face-title">
                <span>国外店型</span>
              </h3>
              <div class="store-face-list">
                <div class="store-face-item">
                  <img src="../../assets/join/out1.png" alt="">
                </div>
                <div class="store-face-item">
                  <img src="../../assets/join/out2.png" alt="">
                </div>
                <div class="store-face-item">
                  <img src="../../assets/join/out3.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block support-section" id="jmzc">
        <div class="section-block-wrap">
          <h1 class="section-title">加盟支持</h1>
          <div class="support-content">
            <div class="support-list flex-wrap flex-between">
              <div class="support-item-block" v-for="(item, index) in supportList" :key="index">
                <div class="support-item">
                  <div class="support-icon">
                    <img :src="item.icon" alt="">
                  </div>
                  <h6 class="support-title">{{ item.title }}</h6>
                  <p class="support-text">{{ item.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block req-section" id="jmyq">
        <div class="section-block-wrap">
          <h1 class="section-title">加盟要求</h1>
          <div class="req-content flex">
            <div class="req-block req-left">
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req1.png" alt="">
                  <span class="req-line"></span>
                </div>
                <div class="req-text-list">
                  <div class="req-text-item">1.  愿意并认同快乐番薯的品牌定位、企业文化、经营模式等一系列品牌理念 </div>
                </div>
              </div>
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req2.png" alt="">
                  <span class="req-line"></span>
                </div>
                <div class="req-text-list">
                  <div class="req-text-item">2.  具备合法的经营资格、积极的从业心态以及良好的商业信誉 </div>
                </div>
              </div>
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req3.png" alt="">
                  <span class="req-line"></span>
                </div>
                <div class="req-text-list">
                  <div class="req-text-item">3.  接受总部制定的考核与技术培训，配合总部统一的品牌营销活动 </div>
                </div>
              </div>
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req4.png" alt="">
                </div>
                <div class="req-text-list">
                  <div class="req-text-item">4.  提供店面选址、人员配备、资金保障，配合总部市场评估，核准后可签约 </div>
                </div>
              </div>
            </div>
            <div class="req-item req-item-m">
              <div class="req-icon">
                <span class="req-line req-line-m"></span>
              </div>
              <div class="req-text-list">
              </div>
            </div>
            <div class="req-block req-right">
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req5.png" alt="">
                  <span class="req-line"></span>
                </div>
                <div class="req-text-list">
                  <div class="req-text-item">5.  门店装修严格执行总部制定的店面设计方案 </div>
                </div>
              </div>
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req6.png" alt="">
                  <span class="req-line req-line-lg"></span>
                </div>
                <div class="req-text-list">
                  <div class="req-text-item">6.  具备店铺条件</div>
                  <div class="req-text-item">店铺面积：15㎡以上</div>
                  <div class="req-text-item">店铺租期：1年以上</div>
                  <div class="req-text-item">店面宽度：门面宽度3m以上</div>
                  <div class="req-text-item">商圈位置：商业进出口、主通道、人流量较大的地方</div>
                  <div class="req-text-item">工程条件：上下水，三相电，16平电缆线，电压30千瓦</div>
                  <div class="req-text-item">网络条件：具有宽带网络</div>
                </div>
              </div>
              <div class="req-item">
                <div class="req-icon">
                  <img src="../../assets/join/req7.png" alt="">
                </div>
                <div class="req-text-list">
                  <div class="req-text-item"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block form-section">
        <div class="section-block-wrap">
          <div class="form-section-wrap flex">
            <div class="form-section-left flex-1">
              <div class="form-title-lg">
                <img class="form-title-img" src="../../assets/join/join-us.png" alt="">
              </div>
              <h2 class="form-title-mid">加盟申请</h2>
              <div class="form-tel-block">
                <h6>加盟热线：</h6>
                <a href="tel:400-6600-326">400-6600-326</a>
              </div>
            </div>
            <div class="form-section-content">
              <div class="form-item form-request">
                <input class="form-item-input" type="text" v-model="formData.name" placeholder="请输入您的姓名">
              </div>
              <div class="form-item form-request">
                <input class="form-item-input" type="number" v-model="formData.phone" placeholder="请输入您的联系电话">
              </div>
              <div class="form-item form-get-code flex">
                <input class="form-item-input" type="text" v-model="formData.code" placeholder="请输入验证码">
                <button class="btn-get-code" @click="getVerfyCode">{{ second < 60? second + '秒后重新获取' : '获取验证码' }}</button>
              </div>
              <div class="form-item form-item-area">
                <div class="form-label">请选择意向区域</div>
                <div class="form-area-block">
                  <select-area @change="areaChange"></select-area>
<!--                  <uni-data-picker-->
<!--                      class="area-input"-->
<!--                      :border="false"-->
<!--                      :localdata="areaData"-->
<!--                      v-model="areaValue"-->
<!--                      popup-title="请选择地区"-->
<!--                      @change="areaChange"-->
<!--                  ></uni-data-picker>-->
                  <!--                  <div class="form-area-item">-->
                  <!--                    <input class="flex-1" type="text" placeholder="请选择省">-->
                  <!--                  </div>-->
                  <!--                  <div class="form-area-item">-->
                  <!--                    <input class="flex-1" type="text" placeholder="请选择市">-->
                  <!--                  </div>-->
                  <!--                  <div class="form-area-item">-->
                  <!--                    <input class="flex-1" type="text" placeholder="请选择区">-->
                  <!--                  </div>-->
                </div>
              </div>
              <div class="form-item">
                <textarea class="form-textarea" v-model="formData.comment" placeholder="留言备注"/>
              </div>
              <div class="form-submit-btn" @click="submitForm">立即报名</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <klfs-footer></klfs-footer>
  </div>
</template>

<script>

import KlfsHeader from "@/components/KlfsHeader.vue";
import KlfsFooter from "@/components/KlfsFooter.vue";
import SelectArea from "@/components/SelectArea.vue";
import host from "@/common/config";
const phoneRegex = /^1(3\d|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
export default {
  name: 'BrandPage',
  components: {
    KlfsHeader,
    KlfsFooter,
    SelectArea
  },
  data() {
    return {
      supportList: [
        { icon: require('@/assets/join/support1.png'), title: '选址装修支持', text: '选址由总部特派专家协同，装修由公司提供统一的店面设计图，让您无忧虑创业。' },
        { icon: require('@/assets/join/support2.png'), title: '品牌形象支持', text: '形象拥有统一的品牌识别系统，从服装、配饰胸牌到海报等公司都可统一供给。' },
        { icon: require('@/assets/join/support3.png'), title: '技术培训支持', text: '创新教研中心提供全方位系统培训，为合作商培训产品技术与店面管理为一体的专业人才。' },
        { icon: require('@/assets/join/support4.png'), title: '运营培训支持', text: '为合作商提供成功的运营管理培训支持，综合成功案例，遵循“理论+实践=成功创业”的法则。' },
        { icon: require('@/assets/join/support5.png'), title: '区域发展扶持', text: '总部扶持区域代理客户拓展市场。' },
        { icon: require('@/assets/join/support6.png'), title: '原物料支持', text: '自建工厂、原物料自动化生产、薯圆自主研发，为您提供坚实实惠的供应保障。' },
        { icon: require('@/assets/join/support7.png'), title: '物流配送支持', text: '公司提供快速便捷的配送服务，及时准确地配送原材料与设备，确保火爆开业。' },
        { icon: require('@/assets/join/support8.png'), title: '新品开发支持', text: '定期新品开发，紧跟市场潮流，吸引新客户，激活老客户。' },
        { icon: require('@/assets/join/support9.png'), title: '营销策划支持', text: '提供全年的品牌营销活动方案，定时进行营销推广，锁定目标消费者，活跃新老粉丝。' },
      ],
      areaData: [],
      areaValue: '',
      timer: null,
      second: 60,
      formData: {
        name: '',
        phone: '',
        code: '',
        area: '',
        comment: ''
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    submitForm() {
      if(!this.formData.name) {
        this.$alert('请输入姓名', '提示', {
          confirmButtonText: '确定'
        });
        return
      }
      if(!this.formData.phone) {
        this.$alert('请输入联系电话', '提示', {
          confirmButtonText: '确定'
        });
        return
      }

      if(!phoneRegex.test(this.formData.phone)) {
        this.$alert('请输入正确的电话号码', '提示', {
          confirmButtonText: '确定'
        });
        return
      }

      var klfs_source = sessionStorage.getItem('klfs_source');
      if(klfs_source) {
        this.formData.source = klfs_source
      }

      const urlEncodedData = new URLSearchParams(this.formData).toString();

      this.$util.fetchData(host.mainUrl + '/api/website/contact', urlEncodedData, 'form').then(res => {
        console.log(res)
        if(res.status == 200) {
          // this.$message({
          //   message: '信息提交成功！',
          //   type: 'success',
          //   offset: 120
          // });
          this.$alert('信息提交成功！', '提示', {
            confirmButtonText: '确定'
          });
          this.formData.name = ''
          this.formData.phone = ''
          this.formData.area = ''
          this.formData.comment = ''
          this.formData.name = ''
          this.formData.code = ''
          clearInterval(this.timer)
          this.second = 60
        } else {
          console.log(JSON.stringify(res))
          this.$alert(res.err || '信息提交失败，请重试', '提示', {
            confirmButtonText: '确定'
          });
        }
      })
    },
    getVerfyCode() {
      if(this.second < 60) {
        return
      }
      if(!phoneRegex.test(this.formData.phone)) {
        this.$alert('请输入正确的电话号码', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action)
          }
        });
        return
      }
      let pData = {
        app_sid:'klfs',
        type:6,
        phone: this.formData.phone
      }
      const urlEncodedData = new URLSearchParams(pData).toString();
      this.$util.fetchData(
          host.mainUrl + '/uc/users/applyVCode',
          urlEncodedData, 'form').then(res => {
        console.log(res)
        if(res.status == 200) {
          this.countDown();
          this.$alert('短信验证码已发送！', '提示', {
            confirmButtonText: '确定'
          });
        } else {
          console.log(JSON.stringify(res))
        }
      })
    },
    countDown() {
      this.second--
      this.timer = setInterval(() => {
        this.second--
        if(this.second < 1) {
          this.second = 60
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 省市区选择
    areaChange(res) {
      console.log(res)
      this.formData.area = res[0] + res[1] + res[2]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index-bg-img img {
  display: block;
}
.section-title {
  font-size: 50px;
  color: var(--p);
  text-align: center;
  padding: 90px 0 50px;
}

.section-block-wrap {
  max-width: 1420px;
  padding: 0 20px 80px;
  margin: 0 auto;
  position: relative;
}
.process-section {
  padding-top: 50px;
}


.brand-progress-line {
  height: 0px;
  border-bottom: 1px dashed var(--p);
}
.brand-progress-item {
  width: 22%;
  text-align: center;
  position: relative;
  margin-bottom: -20px;
}
.brand-progress-text {
  line-height: 1.2;
  font-size: 24px;
  margin-bottom: 16px;
}
.brand-year {
  font-size: 20px;
  font-weight: bold;
  color: var(--p);
  position: relative;
  margin-bottom: 20px;
}
.brand-number {
  width: 42px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 50%;
  font-size: 24px;
  color: #fff;
  background-color: var(--p);
  margin: 0 auto;
}
.brand-progress-bottom .brand-progress-item {
  margin-bottom: unset;
  margin-top: -22px;
}
.brand-progress-bottom .brand-progress-text {
  margin-bottom: unset;
  margin-top: 12px;
}
.brand-progress-bottom .brand-year {
  margin-top: 20px;
  margin-bottom: unset;
}
.brand-progress-top .brand-progress-item:last-child,
.brand-progress-bottom .brand-progress-item:first-child {
  width: 11%;
}

.store-face-section {
  background-color: var(--bg);
}
.store-face-col {
  width: 33.33%;
  text-align: center;
}
.store-face-content {
  margin: 0 -20px;
}
.store-face-item {
  padding: 0 25px;
  margin-bottom: 12px;
}
.store-face-item img {
  display: block;
  width: 100%;
}
.store-face-title {
  font-size: 26px;
  font-weight: normal;
  margin-bottom: 18px;
}
.store-face-title span {
  display: inline-block;
  border-bottom: 1px solid #000;
}
.store-face-item img {
  transition: all .5s;
}
.store-face-item:hover img {
  transform: scale(1.1);
}

.support-item-block {
  display: flex;
  width: 30%;
  margin-bottom: 56px;
}
.support-item {
  width: 370px;
  text-align: center;
  background-color: var(--bg);
  padding: 0 40px 25px;
  border-radius: 16px;
  overflow: hidden;
  margin: 0 auto;
  transition: all .5s;
}
.support-item:hover {
  color: #fff;
  background-color: var(--p);
}
.support-title {
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 26px;
}
.support-text {
  font-size: 14px;
}
.support-icon {
  margin: 0 auto 20px;
  position: relative;
}
.support-icon img {
  position: relative;
  z-index: 1;
}
.support-icon:after {
  content: ' ';
  display: block;
  width: 110px;
  height: 160px;
  background-color: #fff;
  position: absolute;
  top: -115px;
  left: 50%;
  margin-left: -55px;
  border-radius: 50%;
}
.support-section .section-block-wrap {
  padding-bottom: 40px;
}

.req-section {
  background-color: #fffdf5;
}
.req-item {
  display: flex;
}
.req-line {
  display: block;
  width: 1px;
  height: 50px;
  border-left: 1px dashed var(--o);
  margin: 8px auto;
}
.req-line-lg {
  height: 180px;
}
.req-text-list {
  font-size: 16px;
  line-height: 26px;
  padding: 8px 0 0 40px;
}
.req-block {
  padding: 0 45px;
}

.form-section {
  padding-top: 100px;
}
.form-title-img {
  display: block;
  width: 100%;
}
.form-title-mid {
  font-family: "bold";
  font-size: 65px;
  color: var(--p);
  margin: 120px 0 80px;
}
.form-tel-block {
  font-family: "bold";
  color: var(--p);
}
.form-tel-block h6 {
  font-size: 30px;
}
.form-tel-block a {
  display: block;
  font-size: 65px;
}
.form-tel-block a:hover {
  text-decoration: underline;
}
.form-section-content {
  width: 560px;
  background-color: var(--p);
  padding: 35px 40px;
  margin-left: 100px;
  border-radius: 30px;
}
.form-item {
  position: relative;
  margin-bottom: 8px;
}
.form-request:before {
  content: '*';
  font-size: 18px;
  position: absolute;
  left: 30px;
  top: 50%;
  color: var(--o);
  margin-top: -10px;
}
.form-item-input {
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-radius: 8px;
  padding: 4px 20px 4px 44px;
  border: 0;
  outline: none;
}
.form-get-code .form-item-input {
  width: auto;
  flex: 1;
}
.btn-get-code {
  width: 160px;
  height: 60px;
  line-height: 60px;
  margin-left: 16px;
  background-color: #fff;
  cursor: pointer;
  border: 0;
  border-radius: 8px;
}
.form-textarea {
  width: 100%;
  height: 160px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  outline: none;
  border: 0;
}
.form-submit-btn {
  width: 230px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: var(--p);
  font-size: 26px;
  background-color: #fff;
  border-radius: 60px;
  margin:20px auto 0;
  cursor: pointer;
  border: 1px solid var(--p);
  transition: all .5s;
}
.form-submit-btn:hover {
  color: #fff;
  background-color: var(--p);
  border-color: #fff;
}
.form-label {
  font-size: 24px;
  margin: 20px 0;
}
::v-deep .area-input .input-value {
  height: 60px;
  font-size: 16px;
  background-color: #fff;
  border-radius: 8px;
  padding-left: 20px;
}
::v-deep .area-input .placeholder {
  font-size: 16px;
}
::v-deep .selected-item-active {
  border-color: var(--p);
}
::v-deep .area-input .check {
  border-color: var(--p);
}

.req-item-m {
  display: none;
}

@media screen and (max-width: 768px) {
  .section-title {
    font-size: 22px;
    padding: 80px 0 20px;
  }
  .section-block-wrap {
    padding: 0 15px 40px;
  }
  .process-section {
    padding-top: 0;
  }
  .brand-progress-item {
    width: 22%;
    margin-bottom: -12px;
  }
  .brand-progress-bottom .brand-progress-item {
    margin-top: -13px;
  }
  .brand-progress-text {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .brand-number {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }
  .brand-year {
    width: 30px;
    height: 30px;
    margin: 0 auto 10px;
  }
  .brand-year img {
    display: block;
    width: 100%;
  }
  .brand-progress-bottom .brand-year {
    margin-top: 10px;
  }
  .brand-progress-top .brand-progress-item:last-child, .brand-progress-bottom .brand-progress-item:first-child {
    width: 11%;
  }

  .store-face-section {
    padding-top: 0;
  }
  .store-face-content {
    flex-direction: column;
    margin: 0;
  }
  .store-face-item {
    padding: 0;
  }
  .store-face-title {
    font-size: 20px;
  }
  .store-face-col {
    width: 100%;
    margin-bottom: 20px;
  }
  .store-face-section .section-block-wrap {
    padding-bottom: 0;
  }

  .support-item-block {
    width: 100%;
    margin-bottom: 20px;
  }
  .support-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .req-content {
    flex-direction: column;
  }
  .req-block {
    padding: 0 10px;
  }
  .req-text-list {
    flex: 1;
    padding-left: 20px;
    padding-top: 0;
    font-size: 14px;
  }
  .req-icon {
    width: 40px;
  }
  .req-icon img {
    display: block;
    width: 100%;
  }
  .req-line {
    height: 40px;
  }
  .req-line-m {
    margin-top: 0;
  }
  .req-item-m {
    display: flex;
    height: 50px;
    padding: 0 10px;
  }
  .req-line-lg {
    height: calc(100% - 50px);
  }

  .form-section {
    padding-top: 40px;
  }
  .form-title-lg {
    width: 50%;
    margin: 0 auto;
  }
  .form-title-mid {
    font-size: 24px;
    text-align: center;
    margin: 10px 0;
  }
  .form-section-wrap {
    flex-direction: column;
  }
  .form-section-content {
    width: 100%;
    padding: 15px 15px 20px 15px;
    margin-left: 0;
  }
  .form-tel-block {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: 20px;
  }
  .form-tel-block h6,
  .form-tel-block a {
    font-size: 18px;
  }
  .form-item {
    margin-bottom: 14px;
  }
  .form-item-input {
    height: 40px;
    padding-left: 20px;
  }
  .form-request:before {
    left: 10px;
  }
  .btn-get-code {
    height: 40px;
    line-height: 40px;
  }
  .form-get-code .form-item-input {
    flex: 1;
  }
  .form-label {
    font-size: 16px;
    margin: 10px 0;
  }
  ::v-deep .select-area-content input {
    height: 40px;
  }
  .form-item-area {
    margin-bottom: 8px;
  }
  .form-textarea {
    height: 80px;
    padding: 16px;
  }
  .form-submit-btn {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin-top: 0;
  }

  .process-section .section-block-wrap {
    padding: 0 10px 40px;
  }

}

</style>
